import SEO from '../components/SEO';
import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import ProblemSolution from "../components/ProblemSolution";
import Services from "../components/Services";
import TrainingTeaser from "../components/TrainingTeaser";
import ConsultingTrack from "../components/ConsultingTrack";
import Portfolio from "../components/Portfolio";
import Insights from "../components/Insights";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {

    return <div>
        <SEO
          title="EDSY Tech | Enterprise .NET SaaS, Cloud, and Reliability Services"
          description="EDSY Tech delivers enterprise .NET SaaS architecture, Azure and AWS cloud engineering, DevOps, security baselines, and board-ready reliability services."
          canonicalPath="/home"
          keywords="EDSY Tech, enterprise SaaS, .NET architecture, Azure cloud, AWS cloud, DevOps, reliability, security baseline, board-ready documentation"
        />
        <Navbar />
        <Hero />
        <ProblemSolution />
        <Services />
        <TrainingTeaser />
        <ConsultingTrack />
        <Portfolio />
        <Insights />
        <Contact />
        <Footer />
    </div>;
}
export default Home;